import * as React from 'react';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import PageHeaderMeta from '@liveauctioneers/caterwaul-components/lib/PageHeaderMeta/PageHeaderMeta';
import useAddNotificationCountToTitle from '@/hooks/useAddNotificationCountToTitle';

type Props = {
    baseUrl: string;
};

const ConsignmentsPageHeaderMeta = ({ baseUrl }: Props) => {
    const { formatMessage } = useIntl();
    const title = useAddNotificationCountToTitle(formatMessage({ id: 'consign_items_to_an_auction' }));
    const description = formatMessage({ id: 'consignments_description' });
    const canonical = `${baseUrl}/consignments`;

    return (
        <PageHeaderMeta
            canonical={canonical}
            description={description}
            title={title}
        />
    );
};

export default React.memo<Props>(ConsignmentsPageHeaderMeta);
